import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Switch, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { EPButton } from '@/components';

import { GeneralContainer } from './styled';
import { EngineStepsContainer } from '../Engine/Common/styled';
import { versionTabs } from '../Engine/CentrifugalCompressors/CentrifugalCompressors.utils';

const General = observer(({ setActiveTab }) => {
  const { engineStore } = useStores();
  const { t } = useTranslation();
  const [shouldDisplayModal, setShouldDisplayModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const hideConfirmationModal = () => setShouldDisplayModal(false);
  const clearAllEngineConfigurations = async () => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        await engineStore.clearAllEngineConfigurations();
        setActiveTab(versionTabs.engine);
      } finally {
        setShouldDisplayModal(false);
      }
    }
  };
  const onClearClicked = () => {
    setIsLoading(false);
    setShouldDisplayModal(true);
  };

  return (
    <GeneralContainer $hasFinishedWizard={engineStore.hasFinishedWizard}>
      <div className="flex-row">
        <>
          <div className="card">
            <EngineStepsContainer>
              <div className="flex-row">
                <div className="component-rows-container">
                  <div className="component-row">
                    <div className="component-label">{t('Clear all engine configurations')}</div>
                    <div className="component-controls">
                      <EPButton size="medium" type="primary">
                        <span className="button-label" onClick={onClearClicked}>
                          {t('clear')}
                        </span>
                      </EPButton>
                    </div>
                  </div>

                  <div className="component-row">
                    <div className="component-label">{t('Engine ready')}</div>
                    <div className="component-controls">
                      <div className="engine-ready-switch-container">
                        <span className="switch-label">{t('true')}</span>
                        <Switch
                          size="small"
                          className="engine-ready-switch"
                          disabled={true}
                          title={t('This feature is currently disabled.')}
                        />
                        <span className="switch-label">{t('false')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!engineStore.isReadOnly && (
                <div className="footer-buttons">
                  <EPButton size="medium" type="primary" className="back-button" disabled={true}>
                    <span className="button-label">{t('cancel')}</span>
                  </EPButton>

                  <EPButton size="medium" type="primary" disabled={true}>
                    <span className="button-label">{t('save')}</span>
                  </EPButton>
                </div>
              )}
              <Modal
                open={!!shouldDisplayModal}
                onCancel={hideConfirmationModal}
                cancelButtonProps={{ disabled: isLoading }}
                okButtonProps={{ disabled: isLoading }}
                onOk={clearAllEngineConfigurations}
                okText={t('yes')}
                cancelText={t('no')}
                centered
                maskClosable={false}
              >
                <span>{t('Are you sure you want to delete all data?')}</span>
              </Modal>
            </EngineStepsContainer>
          </div>
        </>
      </div>
    </GeneralContainer>
  );
});

export default General;
